import { render, staticRenderFns } from "./Consolidar.vue?vue&type=template&id=ed41dd96&"
import script from "./Consolidar.vue?vue&type=script&lang=js&"
export * from "./Consolidar.vue?vue&type=script&lang=js&"
import style0 from "./Consolidar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports